import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

const base =
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full font-display text-sm font-semibold transition-all duration-200 ease-brand focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50";

const variants = {
  primary:
    "bg-brand-emerald text-brand-black px-6 py-3 hover:bg-brand-snow hover:shadow-glow-emerald active:scale-[0.98]",
  azure:
    "bg-brand-azure text-brand-snow px-6 py-3 hover:brightness-110 hover:shadow-glow-azure active:scale-[0.98]",
  outline:
    "border border-brand-mist/30 text-brand-snow px-6 py-3 hover:border-brand-emerald hover:text-brand-emerald active:scale-[0.98]",
  ghost: "text-brand-mist px-4 py-2 hover:text-brand-snow",
};

const sizes = { sm: "px-4 py-2 text-xs", md: "", lg: "px-8 py-4 text-base" };

export const SiteButton = ({
  variant = "primary",
  size = "md",
  to,
  href,
  className,
  testid,
  children,
  ...props
}) => {
  const cls = cn(base, variants[variant], sizes[size], className);
  if (to) {
    return (
      <Link to={to} className={cls} data-testid={testid} {...props}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={cls} data-testid={testid} {...props}>
        {children}
      </a>
    );
  }
  return (
    <button className={cls} data-testid={testid} {...props}>
      {children}
    </button>
  );
};
